/** First cap: panel pushes layout (flex column width). */
export const DOCS_PUSH_MAX_RATIO = 0.3;
/** Second cap: panel may extend over main content (total panel width). */
export const DOCS_OVERLAY_MAX_RATIO = 0.7;

export const RESIZE_HANDLE_WIDTH_PX = 6;
export const PANEL_WIDTH_TRANSITION_MS = 220;
export const PANEL_WIDTH_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

/** Open-in-new-tab dock control — fixed fallbacks when theme palette omits blue tokens. */
export const DOCS_OPEN_NEW_TAB_BUTTON_BG = '#0967d2';
export const DOCS_OPEN_NEW_TAB_BUTTON_BORDER = '#085dbf';
